
export const GLOBAL = {
  MANAGE_SECURITY_QUESTION_HEADING: "MANAGE_SECURITY_QUESTION_HEADING",
  TRUE_STR_TEXT: 'true',
  FUNCTION: "function",
  OBJECT: "object",
  BOOLEAN: "boolean",
  TEXT: "text",
  NUMBER: "number",
  STRING: "string",
  ARRAY: "array",
  ASC: "asc",
  DESC: "desc",
  YES_TEXT_SHORT: "Y",
  INPUT: "INPUT",
  FOCUS_IN: "focusin",
  FOCUS_OUT: "focusout",
  MOBILE_TEXT: "mobile",
  TABLET_TEXT: "tablet",
  AMOUNT: "amount",
  BACKSPACE: "Backspace",
  DELETE: "Delete",
  LOADING: "LOADING",
  NUMERIC: "numeric",
  BIGDECIMAL: "BIGDECIMAL",
  FAIL: 'fail',
  ARROWLEFT: "ArrowLeft",
  ARROWRIGHT: "ArrowRight",
  ENTER: "Enter",
  KEY_CODE_13: "13",
  SPACEBAR: "Spacebar",
  SPACE: "Space",
  ARROWUP: "ArrowUp",
  ARROWDOWN: "ArrowDown",
  Airtel_Lite: "Airtel Lite",
  DARK: "dark",
  LIGHT: "light",
};
export const RELOAD = 'reload'
export const DISMISS = 'DISMISS'
export const GSM_TEXT = 'gsm'
export const LAST = "LAST"
export const TRANSACTIONS = "TRANSACTIONS"
export const RECHARGE = "recharge"
export const SUCCESSFUL_TEXT = "SUCCESSFUL"
export const AM_TXN_HISTORY = "AM_TXN_HISTORY"
export const TZ="TZ"
export const MORE = "More";
export const LESS = "Less";
export const SESSION_ID = "sessionId";
export const LOGIN_EVENT_TYPES = {
  LOGIN_INITIATED: "LOGIN_INITIATED",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILURE: "LOGIN_FAILURE"
};
export const LOGIN_TYPES = {
  HE: "HE",
  OTP: "OTP",
  SECURE_SMS: "SECURE_SMS"
};
export const LOGIN_PHASE = {
  INITIATED: "INITIATED",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
};

export const EVENT_TYPES = {
  ALL: ["GA", "tcr", "webE"],
  GA: "GA",
  TCR: "tcr",
  webE: "webE"
}